import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ButtonLanguage from "../../utils/ButtonLanguage/ButtonLanguage";

const BurgerMenu = () => {
  const navigate = useNavigate();

  const [isBurgerClicked, setBurgerClicked] = useState(false);
  const [isOverlayShown, setOverlayShown] = useState(false);
  const [isNavShown, setNavShown] = useState(false);
  const [isBodyOverflow, setBodyOverflow] = useState(false);
  const [isLightBackground, setIsLightBackground] = useState(true);

  useEffect(() => {
    const backgroundColor = getComputedStyle(document.body).backgroundColor;

    const brightness = calculateBrightness(backgroundColor);

    setIsLightBackground(brightness > 128);
  }, []);

  const calculateBrightness = (color) => {
    const rgb = color.match(/\d+/g);
    const brightness = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
    return brightness;
  };

  const handleToggle = () => {
    setBurgerClicked(!isBurgerClicked);
    setOverlayShown(!isOverlayShown);
    setNavShown(!isNavShown);
    setBodyOverflow(!isBodyOverflow);
  };

  const navigateTo = (name) => {
    navigate(name);
    setBurgerClicked(false);
    setOverlayShown(false);
    setNavShown(false);
    setBodyOverflow(false);
  };

  return (
    <div className="burger-menu-container">
      <div 
        className={`burger-menu-icon ${isBurgerClicked ? "clicked" : ""}`} 
        onClick={handleToggle}
      >
        {isBurgerClicked ? (
          <img 
            src="/assets/icons/burger-close.png" 
            alt="Close menu" 
            className="burger-menu-logo"
          />
        ) : (
          <img 
            src="/assets/icons/burger-black.png" 
            alt="Open menu" 
            className="burger-menu-logo"
          />
        )}
      </div>

      <div 
        className={`burger-menu-overlay ${isOverlayShown ? "visible" : ""}`} 
        onClick={handleToggle}
      ></div>

      <nav className={`burger-menu-nav ${isNavShown ? "visible" : ""}`}>
        <ul className="burger-menu-list">
          <li className="burger-menu-item">
            <a 
              className="burger-menu-link" 
              onClick={() => navigateTo("/")}
            >
              Accueil
            </a>
          </li>
          <li className="burger-menu-item">
            <a 
              className="burger-menu-link" 
              onClick={() => navigateTo("/cartes")}
            >
              Cartes
            </a>
          </li>
          <li className="burger-menu-item">
            <a 
              className="burger-menu-link" 
              onClick={() => navigateTo("/events")}
            >
              Événements
            </a>
          </li>
          <li className="burger-menu-item">
            <a 
              className="burger-menu-link" 
              onClick={() => navigateTo("/contact")}
            >
              Contact
            </a>
          </li>
        </ul>
        <a style={{textDecoration:"none", color:"#FFF"}} href="https://www.google.com/search?sca_esv=aac09e88d3bc5d88&sxsrf=AHTn8zpYLfWJPJDMWtJMYHYziryE-bmztw:1739024932459&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzY3GiLrROoEZJR1bjEthMJSqz2GD2--oQNY6AscyexC50MavytqGsBr21YMR-0yPLLTEyebwjqXIa2giWqZYmu8A5uu3&q=Restaurant+Le+BLR+Avis&sa=X&ved=2ahUKEwi0_urapLSLAxWTK_sDHRgYJV4Q0bkNegQIQRAE&biw=1586&bih=862&dpr=2&zx=1739024952584&no_sw_cr=1&sei=TmqnZ-u4HfCikdUPyYL28A4" >
          <div className="link" style={{marginTop:"40px",display:"flex",alignItems:"center",textDecoration:"none"}}>
            <img style={{width:"30px",height:"30px"}} src="/assets/icons/star.png" alt="avis google" />
            <div style={{marginLeft:10, fontSize: "1.5rem",fontWeight: 600}} >Avis</div>
          </div>
        </a>
      </nav>
    </div>
  );
};

export default BurgerMenu;
